import { render, staticRenderFns } from "./RouteTag.vue?vue&type=template&id=e4edaf7e&scoped=true&lang=html&functional=true&"
import script from "./RouteTag.vue?vue&type=script&lang=js&"
export * from "./RouteTag.vue?vue&type=script&lang=js&"
import style0 from "./RouteTag.vue?vue&type=style&index=0&id=e4edaf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "e4edaf7e",
  null
  
)

export default component.exports